module.exports = __webpack_public_path__ + "static/media/mbsns3.99e90837.svg";